<div class="p-2 md:p-4" [attr.data-testid]="getFormContainerTestId()">
  @if (form) {
    @if (fields) {
      <form [formGroup]="form" #dataForm="ngForm" (ngSubmit)="onSubmit()">
        <formly-form [model]="dataModel" [fields]="fields" [options]="options" [form]="form"></formly-form>
        @if (dataForm.submitted && !form.valid) {
          <div [attr.data-testid]="getTestId('error', 'validation', moduleName)" class="text-red-500 text-sm mb-2">
            Please correct the highlighted errors.
          </div>
        }
        <div class="flex flex-row w-full gap-2 items-center max-md:sticky max-md:bottom-0 max-md:z-40 max-md:bg-card max-md:py-3"
          [class.justify-end]="buttonPositionAtEnd"
          [class.justify-between]="!buttonPositionAtEnd">
          @if (!hideCancel) {
            <button type="button" (click)="onCancel()" mat-raised-button class="min-h-11" [attr.data-testid]="getTestId('btn', 'cancel', moduleName || formUrl)">
              <mat-icon class="mr-2" [svgIcon]="'heroicons_outline:arrow-circle-left'"></mat-icon>
              <span>Cancel</span>
            </button>
          }
          @if (!hideSubmit) {
            <button type="submit" color="primary" mat-raised-button class="flex-row-reverse submit-button min-h-11"
              [disabled]="!form?.valid || isDisabled" [attr.data-testid]="getTestId('btn', 'save', moduleName || formUrl)">
              <!-- <mat-icon class="mr-2" [svgIcon]="'heroicons_outline:save'"></mat-icon> -->
              <span>Save</span>
              <mat-icon class="ml-2" svgIcon="heroicons_outline:check-circle"></mat-icon>
            </button>
          }
        </div>
      </form>
    }
  }
</div>
